/**
 * @generated SignedSource<<bb26e17b9f2a7b5d89da7831620b24b3>>
 * @relayHash b84889abb0e4c217dc014634b358dfdb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a7593602678f0bdfe2a41a8ba43f10a0ed3f26a1b60b2e272f60ff943ddaab8e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_getIssueTransitionByIdRootQuery } from './main_getIssueTransitionByIdRootQuery.graphql';

import isLicenseCapabilitySetEnabled_provider from '@atlassian/jira-relay-provider/src/platform-forge-ui-license-capability-set.relayprovider';

const node: PreloadableConcreteRequest<main_getIssueTransitionByIdRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a7593602678f0bdfe2a41a8ba43f10a0ed3f26a1b60b2e272f60ff943ddaab8e",
    "metadata": {},
    "name": "main_getIssueTransitionByIdRootQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcplatformforgeuilicensecapabilitysetrelayprovider": isLicenseCapabilitySetEnabled_provider
    }
  }
};

export default node;
